// This is the one place the React Aria trigger is allowed, since it is what
// the lint rule points everything else at.
/* oxlint-disable no-restricted-imports */
import type { FC } from "react";
import {
  TooltipTrigger as AriaTooltipTrigger,
  type TooltipTriggerComponentProps,
} from "react-aria-components";

/**
 * Long enough that a tooltip doesn't flash up while the pointer is on its way
 * somewhere else. It is only paid on the first tooltip: React Aria keeps a
 * global warm state, so anything hovered straight after opens immediately.
 */
export const tooltipDelay = 300;

/**
 * `TooltipTrigger` with our delay rather than React Aria's 1.5 seconds.
 *
 * Use this everywhere instead of the React Aria one, so tooltips across the
 * apps all open on the same beat.
 */
export const TooltipTrigger: FC<TooltipTriggerComponentProps> = (props) => (
  <AriaTooltipTrigger delay={tooltipDelay} {...props} />
);
